const emptyCharacterImpact = () => ({
	time: 0,
	amount: 0,
	skills: 0,
	motivation: 0,
	risk: 0,
});

export const buildEventImpact = ({ selectedCard, selectedOption }) => {
	const isSuccessfulCard = selectedCard === 'happy';
	const isFailedCard = selectedCard === 'sad';

	if (!isSuccessfulCard && !isFailedCard) {
		return {
			characters: {},
			header: { team: 0, teamLeader: 0, organization: 0 },
		};
	}

	const characterImpacts = isSuccessfulCard
		? selectedOption.SuccessImpact
		: selectedOption.FailureImpact;
	const systemImpacts = isSuccessfulCard
		? selectedOption.SuccessSystemImpact
		: selectedOption.FailureSystemImpact;

	const characters = characterImpacts.reduce((impactsByCharacter, impact) => {
		const characterId = impact.Character.key;
		const characterImpact = impactsByCharacter[characterId] || emptyCharacterImpact();

		characterImpact.time += impact.time;
		characterImpact.amount += impact.money;
		characterImpact.skills += impact.skills;
		characterImpact.motivation += impact.motivation;
		characterImpact.risk += impact.retentionRisk;
		impactsByCharacter[characterId] = characterImpact;

		return impactsByCharacter;
	}, {});

	const header = systemImpacts.reduce((headerImpact, impact) => ({
		team: headerImpact.team + impact.team,
		teamLeader: headerImpact.teamLeader + impact.teamLeader,
		organization: headerImpact.organization + impact.organization,
	}), { team: 0, teamLeader: 0, organization: 0 });

	return { characters, header };
};
